var map = {
	"./ar.json": "af08",
	"./ca.json": "a4e4",
	"./de_DE.json": "79e5",
	"./en.json": "edd4",
	"./es.json": "a306",
	"./fr_FR.json": "23bf",
	"./hi.json": "7a03",
	"./hu.json": "4e73",
	"./it_IT.json": "3728",
	"./ja_JP.json": "c5d2",
	"./ko_KR.json": "d42f",
	"./nb_NO.json": "0369",
	"./nl_NL.json": "d9de",
	"./pl.json": "89b2",
	"./pt_BR.json": "0c31",
	"./ru_RU.json": "c473",
	"./zh_CN.json": "752b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";